export function productNav() {
    const nav = document.querySelector('[data-product-nav]');
    const sentinel = document.querySelector('[data-product-nav-sentinel]');
    if (!nav || !sentinel || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
        ([entry]) => nav.classList.toggle('is-stuck', !entry.isIntersecting),
        { threshold: 0 }
    );
    observer.observe(sentinel);
}
